import AppRoute, { type AppRouteProps } from "components/AppRoute/AppRoute";
import type React from "react";
import cookieStorage from "../../persistence";

export interface AuthRouteProps extends AppRouteProps {
  component: React.FC;
}

export const AuthRoute: React.FC<AuthRouteProps> = (props) => (
  <AppRoute {...props} token={cookieStorage.getToken()} />
);
